"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowType = void 0;
var FlowType;
(function (FlowType) {
    FlowType["NEW_WIRELESS"] = "NEW_WIRELESS";
    FlowType["NEW_DTVS"] = "NEW_DTVS";
    FlowType["NEW_BROADBAND"] = "NEW_BROADBAND";
    FlowType["NEW_DTV_NOW"] = "NEW_DTVNOW";
    FlowType["CRP"] = "CRP";
    FlowType["NEW_DTV_NOW_CRP"] = "NEW_DTV_NOW_CRP";
    FlowType["NEW_DTVNOW_EXISTING_WIRELESS"] = "NEW_DTVNOW_EXISTING_WIRELESS";
    FlowType["UNKNOWN"] = "UNKNOWN";
    FlowType["WIRELESS_PREPAID"] = "PREPAID";
    FlowType["NEW_DTVNOW_NEW_WIRELESS"] = "NEW_DTVNOW_NEW_WIRELESS";
    FlowType["NEW_DTVNOW_EXISTING_WIRELESS_CRP"] = "NEW_DTVNOW_EXISTING_WIRELESS_CRP";
    FlowType["NEW_IPTV"] = "NEW_IPTV";
    FlowType["NEW_DTVS_ACCESSORY"] = "NEW_DTVS_NEW_ACCESSORY";
    FlowType["NEW_DTVNOW_NEW_BROADBAND"] = "NEW_DTVNOW_NEW_BROADBAND";
    FlowType["UPGRADE_WIRELESS"] = "UPGRADE_WIRELESS";
    FlowType["UP_AL_WIRELESS"] = "UP_AL_WIRELESS";
    FlowType["AAL_WIRELESS"] = "AAL_WIRELESS";
    FlowType["NEW_IPTV_NEW_BROADBAND"] = "NEW_IPTV_NEW_BROADBAND";
    FlowType["NEW_DTVS_NEW_BROADBAND"] = "NEW_DTVS_NEW_BROADBAND";
    FlowType["NEW_DTVNOW_EXISTING_BROADBAND"] = "NEW_DTVNOW_EXISTING_BROADBAND";
    FlowType["EXISTING_DTVNOW_NEW_BROADBAND"] = "EXISTING_DTVNOW_NEW_BROADBAND";
    FlowType["EXISTING_BROADBAND_NEW_DTVNOW"] = "EXISTING_BROADBAND_NEW_DTVNOW";
    FlowType["NEW_BROADBAND_NEW_HBOMAX"] = "NEW_BROADBAND_NEW_HBOMAX";
    FlowType["EXISTING_DTVNOW_NEW_BROADBAND_NEW_HBOMAX"] = "EXISTING_DTVNOW_NEW_BROADBAND_NEW_HBOMAX";
    FlowType["NEW_DTVNOW_NEW_BROADBAND_NEW_HBOMAX"] = "NEW_DTVNOW_NEW_BROADBAND_NEW_HBOMAX";
    FlowType["NEW_WIRELESS_NEW_HBOMAX"] = "NEW_WIRELESS_NEW_HBOMAX";
    FlowType["NEW_WIRELESS_ON_ACTIVATION_NEW_HBOMAX"] = "NEW_WIRELESS_ON_ACTIVATION_NEW_HBOMAX";
    FlowType["NEW_DTVS_NEW_BROADBAND_NEW_HBOMAX"] = "NEW_DTVS_NEW_BROADBAND_NEW_HBOMAX";
    FlowType["NEW_WIRELESS_ACTIVATION"] = "NEW_WIRELESS_ACTIVATION";
    FlowType["NEW_WIRELESS_ACTIVATION_NEW_HBOMAX"] = "NEW_WIRELESS_ACTIVATION_NEW_HBOMAX";
    FlowType["AAL_WIRELESS_NEW_HBOMAX"] = "AAL_WIRELESS_NEW_HBOMAX";
})(FlowType = exports.FlowType || (exports.FlowType = {}));
//# sourceMappingURL=CartHelperFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/utils/CartHelperFunctions.js
// module id = 346
// module chunks = 8